
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetParticipants, GetTrialCoordinatorsByTrialIdInstitutionCode, GetTrialCoordinatorsByTrialIdInstitutionCodeResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetTrialCoordinatorsByTrialIdInstitutionCodeResponse, GetTrialCoordinatorsByTrialIdInstitutionCodeResponse>) => response?.data?.personnel;
const getError = (response?: SWRResponse<GetTrialCoordinatorsByTrialIdInstitutionCodeResponse, GetTrialCoordinatorsByTrialIdInstitutionCodeResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetTrialCoordinatorsByTrialIdInstitutionCodeResponse, GetTrialCoordinatorsByTrialIdInstitutionCodeResponse>) => ({});

const useGetTrialInstitutionCoordinators = (query?: Partial<GetTrialCoordinatorsByTrialIdInstitutionCode>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetTrialCoordinatorsByTrialIdInstitutionCode(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetTrialInstitutionCoordinators;